export default "__VITE_ASSET__a7354efe__"